import useOnAlignmentPopupOpen from './useOnAlignmentPopupOpen';

export default useOnAlignmentPopupOpen;